import ProductDetailPage from '../components/products/ProductDetailPage';
import { getProductPageConfig } from '../data/products/productsRegistry';

const PouchesRolls = () => <ProductDetailPage {...getProductPageConfig('pouchesRolls')} />;

export default PouchesRolls;
